export type StyleQuizView = 'welcome' | 'question' | 'result';

export function getStyleQuizPopupContent(
  view: StyleQuizView,
  questionId: number | undefined,
  fallbackContent: string,
): string {
  if (view === 'question') {
    return questionId === undefined ? '' : `Q${questionId}`;
  }

  return fallbackContent;
}

export function getStyleQuizExposurePageKey(
  view: StyleQuizView,
  activeQuestionIndex: number,
  questionId?: number,
): string {
  if (view !== 'question') {
    return view;
  }

  return `${view}:${activeQuestionIndex}:${questionId ?? 'missing'}`;
}

export function resolveStyleQuizExposure(
  previousPageKey: string | null,
  currentPageKey: string | null,
) {
  return {
    nextPageKey: currentPageKey,
    shouldTrack: currentPageKey !== null && currentPageKey !== previousPageKey,
  };
}
